import template from './order-page-holder.html';
var Controller = /** @class */ (function () {
    /*@ngInject*/
    function Controller() {
    }
    return Controller;
}());
export { Controller };
export var OrderPageHolderComponent = {
    template: template,
    controller: Controller,
    transclude: true
};
//# sourceMappingURL=order-page-holder.component.js.map